import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { MultiTraitQueryContext } from '../multi-trait-query-context';

@Component({
    selector: 'jhi-step-introduction',
    styleUrl: './step-introduction.component.css',
    templateUrl: './step-introduction.component.html'
})
export class StepIntroductionComponent implements OnInit {
    @Output() next = new EventEmitter<void>();
    @Input() active = false;

    constructor(public queryContext: MultiTraitQueryContext) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['active'] && this.active) {
            this.queryContext.cleanSelectedTraits();
        }
    }

    ngOnInit(): void {
    }

    nextStep(): void {
        this.next.emit();
    }
}